import { createSelector } from '@reduxjs/toolkit'
import get from 'lodash/get'

const getUserData = (state) => state.user.data

export const getUserPlants = createSelector(
  [getUserData],
  (user) => get(user, 'plants', []) || [],
)

export const getUserManagableRoles = createSelector(
  [getUserData],
  (user) => get(user, 'managable_roles', []) || [],
)

export const getOrganisationType = createSelector([getUserData], (user) => {
  return get(user, 'organization_type', '') || ''
})

export const getFeatureFlags = createSelector(
  [getUserData],
  (user) => get(user, 'feature_flags', []) || [],
)

export const getIsExternalProvider = createSelector(
  [getUserData],
  (user) => get(user, 'external_provider', null) || null,
)

export const getIsUserLoggedIn = createSelector(
  [getUserData],
  (userData) => userData !== null,
)

export const getUserName = createSelector(
  [getUserData],
  (userData) => get(userData, 'username', '') || '',
)
